import React, { useState, useEffect } from 'react';
import './Hero.css';
import slide1 from '../slide1.jpeg';
import slide2 from '../slide2.jpeg';
import slide3 from '../slide3.jpeg';
import schoolIcon from '../school.png';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: slide1,
      title: "RITUALS & SAMSKARAS",
      description: "Traditional Samskaras, Homams, and Shanti rituals performed strictly as per Vedic scriptures with devotion and discipline.",
      buttonText: "Explore Our Gurukulam"
    },
    {
      id: 2,
      image: slide2,
      title: "Traditional Vedic Education",
      description: "Authentic learning of Vedas, Sanskrit, and rituals through oral tradition, daily practice, and direct guidance from experienced acharyas.",
      buttonText: "Explore Our Gurukulam"
    },
    {
      id: 3,
      image: slide3,
      title: "Preserving Timeless Vedic Wisdom",
      description: "Preserving ancient Vedic wisdom through the traditional Guru-Shishya Parampara, nurturing discipline, values, and spiritual learning.",
      buttonText: "Explore Our Gurukulam"
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section className="hero-section">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <div className="container">
                <div className="hero-text">
                  <h1 className="hero-title">
                    {slide.id === 3 ? (
                      <div>
                        <div>Preserving Timeless</div>
                        <div>Vedic Wisdom</div>
                      </div>
                    ) : (
                      slide.title
                    )}
                  </h1>
                  <p className="hero-description">{slide.description}</p>
                  <button className="hero-btn">
                    <img src={schoolIcon} alt="School" className="hero-btn-icon" />
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;